export const PROFILE = [
  ["name", "Nombre y apellidos", "text", "name"],
  ["dni", "DNI / NIE", "text", "off"],
  ["phone", "Teléfono", "tel", "tel"],
  ["line1", "Dirección (calle, número, piso)", "text", "street-address"],
  ["postal_code", "Código postal", "text", "postal-code"],
  ["city", "Ciudad", "text", "address-level2"],
  ["state", "Provincia", "text", "address-level1"],
];
const WIDE = new Set(["name", "line1", "email", "password"]);
const LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";

export const validDni = (raw) => {
  const v = (raw || "").toUpperCase().replace(/[\s-]/g, "");
  const m = v.match(/^([XYZ]?)(\d{7,8})([A-Z])$/);
  if (!m) return false;
  let [, p, d, l] = m;
  if (p) { if (d.length !== 7) return false; d = "XYZ".indexOf(p) + d; } else if (d.length !== 8) return false;
  return LETTERS[Number(d) % 23] === l;
};

export const checkProfile = (v, withAuth) => {
  const e = {};
  const fields = withAuth ? [["email", "Email"], ["password", "Contraseña"], ...PROFILE] : PROFILE;
  fields.forEach(([k, label]) => { if (!(v[k] || "").trim()) e[k] = `${label.split(" (")[0]}: obligatorio`; });
  if (withAuth && v.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) e.email = "Email no válido";
  if (withAuth && v.password && v.password.length < 8) e.password = "Mínimo 8 caracteres";
  if (v.dni && !validDni(v.dni)) e.dni = "DNI/NIE no válido (revisa la letra)";
  if (v.phone && v.phone.replace(/\D/g, "").length < 9) e.phone = "Teléfono no válido";
  if (v.postal_code && !/^\d{5}$/.test(v.postal_code.trim())) e.postal_code = "5 cifras";
  return e;
};

const Field = ({ k, label, type, ac, value, onChange, error }) => (
  <label className={WIDE.has(k) ? "col-span-2" : "col-span-2 sm:col-span-1"}>
    <span className="text-xs text-[#C9D6C2]">{label} *</span>
    <input data-testid={`account-${k}`} type={type} autoComplete={ac} value={value || ""} required aria-invalid={!!error}
      inputMode={k === "postal_code" ? "numeric" : undefined} onChange={(e) => onChange(k, e.target.value)}
      className={`mt-1 w-full h-12 rounded-[8px] bg-[#143823] border px-3 text-[#F6EEDC] outline-none focus:border-[#F2B441] ${error ? "border-[#E5765B]" : "border-[#F6EEDC]/25"}`} />
    {error && <span data-testid={`account-${k}-error`} className="text-xs text-[#F4A58F]">{error}</span>}
  </label>
);

export const ProfileFields = ({ value, onChange, errors, withAuth }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const list = withAuth ? [["email", "Email", "email", "email"], ["password", "Contraseña (mín. 8)", "password", "new-password"], ...PROFILE] : PROFILE;
  return (
    <div className="grid grid-cols-2 gap-3">
      {list.map(([k, label, type, ac]) => <Field key={k} k={k} label={label} type={type} ac={ac} value={value[k]} onChange={set} error={errors[k]} />)}
    </div>
  );
};
